export const stringAvatar = (username: string) =>
    username.split(" ").length > 1
        ? `${username.split(" ")[0][0].toUpperCase()}${username
              .split(" ")[1][0]
              .toUpperCase()}`
        : `${username[0].toUpperCase()}${username[1].toUpperCase()}`;
